const options = {
  spaceId: `n6b6zxdzfyz3`,
  environment:
    // eslint-disable-next-line no-nested-ternary
    process.env.ENVIRONMENT === 'production'
      ? 'master'
      : process.env.ENVIRONMENT === 'staging'
      ? 'staging'
      : 'development',
  accessToken:
    process.env.CONTENTFUL_ACCESS_TOKEN ||
    'Z4nIMOGR4RYvIsyG0ATtBmYD1ikiDA6RX_w5ZZHYXjM',
};

interface Props {
  query: string;
  variables: object | null;
}

const contentfulApi = async ({ query, variables }: Props): Promise<any> =>
  window
    .fetch(
      `https://graphql.contentful.com/content/v1/spaces/${options.spaceId}/environments/${options.environment}/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${options.accessToken}`,
        },
        body: JSON.stringify({ query, variables }),
      },
    )
    .then(response => response.json());

export default contentfulApi;
